async function getAPIToken(){
    var token = isPresentOr(window["API_TOKEN"], Plastic.API["token"]);
    if (isPlainObject(token)) {
        token = objProp(token, "token", null);
    }
    if (isPresent(token)) return token;
    return await Plastic.User.token();
}
async function getAPIURL(options){
    var hasURL = typeof API_URL !== 'undefined';
    var url = hasURL ? isPresentOr(API_URL, Plastic.API.URL) : Plastic.API.URL;
    url = `${url}${options["endpoint"]}`;

    if (isPresent(Plastic.API.qString)){
        url = URLAppendQS(url, Plastic.API.qString);
    }

    return url;
}

/**
 * @alias Plastic.API
 */
var API = async function(options){
    return new Promise(async function(resolve, reject){
        options = objOrSetProp(options, "endpoint");

        var requestOptions = extendObject(options, {
            headers: await getHeaders(),
            method: "GET",
            url: await getAPIURL(options),
        });

        Plastic.Request(requestOptions).then(resolve).catch((e) => {
            console.log(e); reject(e);
        });
    });

    async function getHeaders(){
        var headers = {
            "app-referer-host": Plastic.URL.host,
            "app-referer-path": Plastic.URL.path
        };

        var token = await getAPIToken();
        if (isPresent(token)){
            headers["x-api-key"] = token;
        }

        if (isPresent(Plastic.API.headers)){
            loopProps(Plastic.API.headers, (header, value) => {
                headers[header] = value;
            });
        }

        return headers;
    }
};
API.dependencies = ["URL", "User"];
API.token = null;
API.URL = null;
API.qString = {};
API.headers = {};

API.beacon = function(options){
    options = objOrSetProp(options, "endpoint");

    sendBeacon();

    async function sendBeacon(){
        try {
            var url = await getAPIURL(options);

            var data = objProp(options, "data", {});
            data["x-api-key"] = await getAPIToken();

            navigator.sendBeacon(url, data);
        }
        catch(e){
            console.log(e);
        }
    }
}